import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  Button,
  TextField,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  StepLabel,
  IconButton,
  Alert,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { appSelector } from "../redux/selector";
import {
  addCandidateAction,
  getCitiesAction,
  getCountriesAction,
  getJobTypesAction,
  getStatesAction,
  getZipcodesAction,
} from "../redux/action";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputMask from "react-input-mask";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Key from "../../../src/clientVariables.json";
import Avatar from "@mui/material/Avatar";
import { userSelector } from "../../../src/Components/user-redux/selector";
import { useDispatch, useSelector } from "react-redux";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import EditIcon from "@mui/icons-material/Edit";
import { companyUpdateAction } from "./redux/action";
import { settingsSelector } from "./redux/selector";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import InputAdornment from "@mui/material/InputAdornment";

const AdminProfilesettings = ({
  showPasswordSettings,
  showCompanySettings,
  setIsEditClicked,
  modalOnly = false,
}) => {
  const dispatch = useDispatch();
  const {
    statesList,
    citiesList,
    result,
    countriesList,
    jobTypesList,
    addCandidateResult,
    zipcodesList,
  } = useSelector(appSelector);

  const { user } = useSelector(userSelector);
  const { userDetail } = useSelector(settingsSelector);

  const [openStepper, setOpenStepper] = useState(true);
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState();
  const [error, setError] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [success, setSuccess] = useState("");
  const [hovered, setHovered] = useState(false);
  const [countryError, setCountryError] = useState(false);
  const [stateError, setStateError] = useState(false);
  const [cityError, setCityError] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [profileImageName, setProfileImageName] = useState("");
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [linkedinError, setLinkedinError] = useState("");
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [isLoadingZipcodes, setIsLoadingZipcodes] = useState(false);
  const { primaryResumeDetails } = useSelector(appSelector);

  useEffect(() => {
    const fetch = async () => {
      if (activeStep === 0 && formData?.state) {
        dispatch(getCitiesAction(formData?.state));
      }
      if (activeStep === 1 && formData?.company_state) {
        dispatch(getCitiesAction(formData?.company_state));
      }
      if (activeStep === 2 && formData?.company_city) {
        dispatch(getZipcodesAction(formData?.company_city));
      }
    };

    fetch();
  }, [activeStep]);

  const isCandidateUser = Number(user?.usertype) === 6;

  const getValidText = (...values) => {
    for (const value of values) {
      if (value === null || value === undefined) continue;
      const text = String(value).trim();
      if (!text) continue;
      if (text.toLowerCase() === "undefined" || text.toLowerCase() === "null") continue;
      return text;
    }
    return "N/A";
  };


  const linkedInUrl = isCandidateUser
    ? getValidText(user?.linkedin_url, primaryResumeDetails?.linkedin_url)
    : getValidText(user?.linkedin_url);


  const phoneNumber = isCandidateUser
    ? getValidText(user?.phone_number, primaryResumeDetails?.home_phone)
    : getValidText(user?.phone_number);


  useEffect(() => {
    if (user?.state) {
      dispatch(getCitiesAction(user.state));
    }
    if (user?.company_state) {
      dispatch(getCitiesAction(user.company_state));
    }
    if (user?.company_city) {
      dispatch(getZipcodesAction(user.company_city));
    }
    dispatch(getCountriesAction());
    dispatch(getStatesAction(233));
    dispatch(getJobTypesAction());
    //console.log("Initial user data:", user);
    const linkedinUrl = user.linkedin_url || user.linkedinURL || "";
    const objData = {
      id: user.id,
      companyid: user.companyid || 0,
      full_name: user.full_name,
      url: user.url || "",
      domain_name: "",
      email_domain: "",
      aboutcompany: "",
      contactname: user.contactname || "",
      contactphone: phoneNumber || "",
      contactemail: user.contactemail || "",
      company_country: user.company_country || 233,
      company_state: user.company_state || "",
      company_city: user.company_city || "",
      company_zipcode: user.company_zipcode || "",
      company_address1: user.company_address1 || "",
      company_address2: user.company_address2 || "",
      email: user.username || "",
      phone_number: user.phone_number || "",
      state: user.state || "",
      city: user.city || "",
      zipcode: user.zipcode || "",
      address: user.address || "",
      companyName: user.companyname || user.company_name || "",
      linkedin_url: linkedInUrl || "",
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
    //console.log("Setting initial form data:", objData);
    setFormData(objData);
  }, [user]);

  useEffect(() => {
    //console.log(activeStep);

    if (activeStep > 0) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  }, [userDetail]);

  useEffect(() => {
    //console.log("userDetail changed:", userDetail);
    if (userDetail) {
      setFormData(prevData => {
        const linkedinUrl = userDetail.linkedin_url || userDetail.linkedinURL || prevData?.linkedin_url || "";
        const newData = {
          ...prevData,
          linkedin_url: linkedinUrl,
        };
        //console.log("Updated formData after userDetail change:", newData);
        return newData;
      });
    }
  }, [userDetail]);

  useEffect(() => {
    //console.log("showPasswordSettings", showPasswordSettings);
    if (showPasswordSettings) {
      setActiveStep(3); // Set activeStep to 1 when showPasswordSettings is true
    }
  }, [showPasswordSettings]);

  useEffect(() => {
    if (showCompanySettings) {
      setActiveStep(1); // Set activeStep to 1 when showPasswordSettings is true
    }
  }, [showCompanySettings]);

  // useEffect(() => {
  //   console.log("Current form data:", formData);
  // }, [formData]);

  useEffect(() => {
    //console.log("Zipcodes list updated:", zipcodesList);
    setIsLoadingZipcodes(false); // Stop loading when zipcodes are fetched
  }, [zipcodesList]);

  useEffect(() => {
    setIsLoadingCities(false); // Stop loading when cities are fetched
  }, [citiesList]);

  const nextStep = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };
  useEffect(() => {
    if (user?.image && user?.id) {
      const url = `https://${Key.aws_bucket_bench}.s3.amazonaws.com/attachments/user_${user.id}/profileimages/${user.image}`;
      setProfileImage(url);
      setProfileImageName(user.image);
    }
  }, [user]);

  const handleSubmit = async () => {
    const isCountryValid = formData.countryid !== "";
    const isStateValid = formData.stateid !== "";
    const isCityValid = formData.cityid !== "";
    const isLinkedinValid = !linkedinError;

    setCountryError(!isCountryValid);
    setStateError(!isStateValid);
    setCityError(!isCityValid);

    if (!isCountryValid || !isStateValid || !isCityValid || !isLinkedinValid) {
      return;
    }

    const ret4 = formData?.url?.replace("www.", "");
    const ret3 = ret4.replace("http://", "");
    const ret2 = ret3.replace("https://", "");
    const ret1 = ret2.replace("http://www.", "");
    const finalurl = ret1.replace("https://www.", "");
    const domain_name = finalurl.replace("/", "");

    const forEmailDomain = formData?.email;
    const emailDomainArr = forEmailDomain.split("@");
    const email_domain = emailDomainArr[1];

    // Data to be sent in POST request
    const postData = {
      id: formData?.id,
      companyid: formData?.companyid || 0,
      full_name: formData?.full_name,
      url: formData?.url || "",
      domain_name: domain_name,
      email_domain: email_domain,
      aboutcompany: "",
      contactname: formData?.contactname || "",
      contactphone: formData?.contactphone || "",
      contactemail: formData?.contactemail || "",
      company_country: formData?.company_country || 233,
      company_state: formData?.company_state || "",
      company_city: formData?.company_city || "",
      company_zipcode: formData?.company_zipcode || "",
      company_address1: formData?.company_address1 || "",
      company_address2: formData?.company_address2 || "",
      email: formData?.email || "",
      phone_number: formData?.phone_number || "",
      state: formData?.state || "",
      city: formData?.city || "",
      zipcode: formData?.zipcode || "",
      address: formData?.address || "",
      companyName: formData?.companyName || "",
      usertype: user?.usertype,
      image: profileImageName || user?.image || "",
      linkedin_url: formData?.linkedin_url || "",
      linkedinURL: formData?.linkedin_url || "",
    };

    //console.log("Submitting postData:", postData);
    dispatch(companyUpdateAction(postData));
  };

  const steps = [
    "User Details",
    "Register Your Company",
    "Add Address",
    "Change Password",
  ];
  const lowerStep = [
    "We'd love to hear from you. Please fill out this form",
    "Kindly provide all required details to register your company with us",
    "Kindly provide your company address details for registration with us",
    "Kindly update your password to enhance security",
  ];

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const handleChangePassword = async (event) => {
    event.preventDefault();
    const { currentPassword, newPassword, confirmPassword } = formData;

    // Clear previous messages
    setError("");
    setSuccess("");

    // Validations (simplified)
    if (newPassword !== confirmPassword) {
      setError("New passwords don't match");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }

    try {
      const response = await fetch(`${Key.domain}/common/change_password`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.username,
          currentPassword: currentPassword,
          newPassword: newPassword
        }),
      });

      const result = await response.json();

      if (response.ok && result.success === 1) {
        setSuccess("Password changed successfully!");
        setIsEditClicked(false);
        // Optional: Force logout after password change
        // await logout();
      } else {
        setError(result.error || "Failed to change password");
      }
    } catch (error) {
      setError("Network error. Please try again.");
    }
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    //console.log("Input change:", { name, value, currentFormData: formData });

    if (name === 'linkedin_url') {
      setFormData(prev => {
        const newData = { ...prev, linkedin_url: value };
        //console.log("Updated LinkedIn URL:", newData);
        return newData;
      });
      const linkedinRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[\w-]+\/?$/;
      if (value && !linkedinRegex.test(value)) {
        setLinkedinError("Please enter a valid LinkedIn profile URL");
      } else {
        setLinkedinError("");
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handlePhotoUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setProfileImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
    if (!file) {
      //console.log("No file selected");
      return;
    }

    // Validate file type (image)
    if (!file.type.startsWith("image/")) {
      setUploadError("Please select an image file");
      console.log("Invalid file type");
      return;
    }

    // Validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      setUploadError("Image size should be less than 5MB");
      console.log("File too large");
      return;
    }

    // Preview the selected image immediately
    const previewUrl = URL.createObjectURL(file);
    setProfileImage(previewUrl);

    setIsUploading(true);
    setUploadError("");
    const formData = new FormData();
    formData.append("profile_image", file);
    formData.append("user_id", user.id);

    try {
      //console.log("Uploading file...", file.name);
      const response = await fetch(`${Key.domain}/user/profile/image_upload`, {
        method: "POST",
        headers: {
          Accept: "application/json",
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to upload image");
      }
      const data = await response.json();

      if (data.name) {
        setProfileImageName(data.name);
      } else {
        console.error("Image URL not returned or invalid");
      }

      //console.log("Upload successful:", data);
      setSuccess("Profile picture updated successfully");
    } catch (error) {
      console.error("Error during upload:", error);
      setUploadError(error.message || "Failed to upload image");
    } finally {
      setIsUploading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Email validation

    // Country validation
    if (name === "countryid") {
      setCountryError(value === ""); // Check if it's empty
    }
  };

  const handleCountryChange = (event) => {
    const selectedCountryId = parseInt(event.target.value, 10);
    setFormData((prevData) => ({
      ...prevData,
      country: selectedCountryId,
    }));
    setCountryError(false);
  };

  const handleStateChange = (event) => {
    const selectedStateId = parseInt(event.target.value, 10);
    setFormData((prevData) => ({
      ...prevData,
      state: selectedStateId,
    }));
    setStateError(selectedStateId === "");
    dispatch(getCitiesAction(selectedStateId));
  };

  const handleCitiesChange = (event) => {
    const selectedCityId = parseInt(event.target.value, 10);
    setFormData((prevData) => ({
      ...prevData,
      city: selectedCityId,
    }));
    setCityError(selectedCityId === "");
  };

  const handleCompanyStateChange = (event) => {
    const selectedStateId = parseInt(event.target.value, 10);
    setFormData((prevData) => ({
      ...prevData,
      company_state: selectedStateId,
      company_city: "", // Clear city when state changes
      company_zipcode: "", // Clear zipcode when state changes
    }));
    setStateError(selectedStateId === "");
    setIsLoadingCities(true);
    dispatch(getCitiesAction(selectedStateId));
  };

  const handleCompanyCitiesChange = (event) => {
    const selectedCityId = parseInt(event.target.value, 10);
    setFormData((prevData) => ({
      ...prevData,
      company_city: selectedCityId,
      company_zipcode: "", // Clear zipcode when city changes
    }));
    setCityError(selectedCityId === "");

    // Clear previous zipcodes and fetch new ones
    //console.log("Fetching zipcodes for city ID:", selectedCityId);
    if (selectedCityId) {
      setIsLoadingZipcodes(true);
      dispatch(getZipcodesAction(selectedCityId));
    }
  };

  const handleCompanyZipcodeChange = (event) => {
    const selectedZipcode = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      company_zipcode: selectedZipcode,
    }));
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <Box>
            <Box sx={{ margin: "20px 40px 0 40px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 2,
                  position: "relative",
                }}
              >
                <label>
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={handlePhotoUpload}
                    id="profile-upload"
                  />
                  {profileImage ? (
                    <Box sx={{ position: "relative", width: 80, height: 80 }}>
                      <Avatar
                        src={profileImage}
                        sx={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "50%",
                          transition: "transform 0.2s ease, opacity 0.2s ease",
                          cursor: "pointer",
                          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                          opacity: hovered ? 0.8 : 1,
                        }}
                        onMouseOver={() => setHovered(true)}
                        onMouseOut={() => setHovered(false)}
                        onClick={() =>
                          document.getElementById("profile-upload").click()
                        }
                        alt="Profile"
                      />
                      {/* Show Edit Icon when hovered */}
                      <IconButton
                        color="primary"
                        size="small"
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          opacity: hovered ? 5 : 0,
                          visibility: hovered ? "visible" : "hidden",
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          borderRadius: "50%",
                          transition: "opacity 0.3s ease, visibility 0.3s ease",
                          boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                          "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                          },
                        }}
                        onMouseOver={() => setHovered(true)}
                        onMouseOut={() => setHovered(false)}
                        onClick={() =>
                          document.getElementById("profile-upload").click()
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </Box>
                  ) : (
                    <IconButton
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: 80,
                        height: 80,
                        cursor: "pointer",
                        padding: 0,
                        borderRadius: "50%",
                        backgroundColor: "rgb(233, 236, 239)",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                        transition: "transform 0.2s ease",
                        "&:hover": {
                          transform: "scale(1.1)",
                        },
                      }}
                      onClick={() =>
                        document.getElementById("profile-upload").click()
                      }
                    >
                      <AddAPhotoOutlinedIcon
                        style={{
                          fontSize: "40px",
                          color: "rgb(59, 66, 73)",
                          transition: "transform 0.2s ease",
                          transform: "rotateY(180deg)",
                        }}
                        onMouseOver={(e) =>
                        (e.currentTarget.style.transform =
                          "scale(1.001) rotateY(180deg)")
                        }
                        onMouseOut={(e) =>
                        (e.currentTarget.style.transform =
                          "scale(1) rotateY(180deg)")
                        }
                      />
                    </IconButton>
                  )}
                </label>
              </Box>
            </Box>

            <TextField
              label="Name"
              name="full_name"
              value={formData?.full_name}
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Email"
              name="email"
              value={formData?.email}
              disabled
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />

            <InputMask
              mask="(999) 999-9999"
              value={formData?.phone_number || ""}
              onChange={handleInputChange}
            >
              {() => (
                <TextField
                  label="Phone Number"
                  name="phone_number"
                  fullWidth
                  margin="normal"
                  sx={{
                    width: "calc(100% - 80px)",
                    margin: "9px 40px",
                    "&:hover": {
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                    },
                  }}
                />
              )}
            </InputMask>
            <TextField
              label="LinkedIn Profile"
              name="linkedin_url"
              value={formData?.linkedin_url || ""}
              onChange={(e) => {
                const value = e.target.value;
                //console.log("LinkedIn input change:", value);
                handleInputChange(e);
              }}
              placeholder="https://www.linkedin.com/in/your-profile"
              error={!!linkedinError}
              helperText={linkedinError}
              fullWidth
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <FormControlLabel
              sx={{ margin: "9px 30px" }}
              control={<Checkbox defaultChecked />}
              label={
                <span>
                  You agree to{" "}
                  {/* <Typography
                    component="span"
                    sx={{ textDecoration: "underline" }}
                  > */}
                  Terms and Conditions
                  {/* </Typography> */}
                </span>
              }
            />
          </Box>
        );
      case 1:
        return (
          <Box>
            <TextField
              label="Company Name"
              name="companyName"
              value={formData?.companyName}
              disabled
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />

            <TextField
              label="Url"
              name="url"
              value={formData?.url}
              disabled={user?.url ? true : false}
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Contact Name"
              name="contactname"
              value={formData?.contactname}
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Contact Email"
              name="contactemail"
              value={formData?.contactemail}
              onChange={handleInputChange}
              margin="normal"
              disabled // <-- Add this line to make the field read-only
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />

            <InputMask
              mask="(999) 999-9999"
              value={formData?.contactphone}
              onChange={handleInputChange}
            >
              {() => (
                <TextField
                  label="Contact Number"
                  name="contactphone"
                  fullWidth
                  margin="normal"
                  sx={{
                    width: "calc(100% - 80px)",
                    margin: "9px 40px",
                    "&:hover": {
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      transition: "all 0.3s ease-in-out",
                    },
                  }}
                />
              )}
            </InputMask>
          </Box>
        );
      case 2:
        return (
          <Box>
            <TextField
              label="Address"
              name="company_address1"
              value={formData?.company_address1}
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            {/* <TextField
              label="Street Address"
              name="company_address2"
              value={formData?.company_address2}
              onChange={handleInputChange}
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            /> */}
            <FormControl
              variant="outlined"
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
              error={countryError}
            >
              <InputLabel id="country-label">Country</InputLabel>
              <Select
                labelId="country-label"
                id="country-select"
                value={formData?.company_country || ""} // Ensure this matches the integer ID
                onChange={handleCountryChange}
                label="Country"
                name="company_country"
              >
                {countriesList?.length > 0 &&
                  countriesList.map((country) => (
                    <MenuItem key={country.id} value={country.id}>
                      {country.name}
                    </MenuItem>
                  ))}
              </Select>

              {countryError && (
                <Typography variant="caption" color="error">
                  Country is required
                </Typography>
              )}
            </FormControl>
            <FormControl
              variant="outlined"
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
              error={stateError}
            >
              <InputLabel id="state-label">State</InputLabel>
              <Select
                labelId="state-label"
                id="state-select"
                value={formData?.company_state || ""} // Default to '' if undefined
                onChange={handleCompanyStateChange}
                label="State"
                name="company_state"
                error={stateError}
                helpertext={stateError ? "State is required" : ""}
              >
                {statesList?.length > 0 &&
                  statesList?.map((state, index) => (
                    <MenuItem key={index} value={state.id} name={state.name}>
                      {state.name}
                    </MenuItem>
                  ))}
              </Select>

              {stateError && (
                <Typography variant="caption" color="error">
                  State is required
                </Typography>
              )}
            </FormControl>
            <FormControl
              variant="outlined"
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
              error={cityError}
            >
              <InputLabel id="city-label">
                {isLoadingCities ? "Loading Cities..." : "City"}
              </InputLabel>
              <Select
                label="City"
                variant="outlined"
                fullWidth
                name="company_city"
                value={formData?.company_city || ""}
                onChange={handleCompanyCitiesChange}
                disabled={isLoadingCities || !formData?.company_state}
                inputlabelprops={{
                  style: { fontSize: "12px" }, // Adjust the font size as needed
                }}
                endAdornment={
                  isLoadingCities && (
                    <CircularProgress size={20} sx={{ mr: 2 }} />
                  )
                }
              >
                {!isLoadingCities && citiesList?.length > 0 &&
                  citiesList?.map((city, index) => (
                    <MenuItem key={index} value={city.id} name={city.name}>
                      {city.name}
                    </MenuItem>
                  ))}
                {!isLoadingCities && citiesList?.length === 0 && (
                  <MenuItem value="" disabled>
                    {!formData?.company_state ? "Please select a state first" : "No cities available"}
                  </MenuItem>
                )}
              </Select>
              {cityError && (
                <Typography variant="caption" color="error">
                  City is required
                </Typography>
              )}
            </FormControl>
            <FormControl
              variant="outlined"
              margin="normal"
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            >
              <InputLabel id="zipcode-label">
                {isLoadingZipcodes ? "Loading Postal Codes..." : "Postal Code"}
              </InputLabel>
              <Select
                labelId="zipcode-label"
                id="zipcode-select"
                value={formData?.company_zipcode || ""}
                onChange={handleCompanyZipcodeChange}
                label="Postal Code"
                name="company_zipcode"
                disabled={!formData?.company_city || isLoadingZipcodes}
                endAdornment={
                  isLoadingZipcodes && (
                    <CircularProgress size={20} sx={{ mr: 2 }} />
                  )
                }
              >
                <MenuItem value="" disabled>
                  {!formData?.company_city
                    ? "Please select a city first"
                    : isLoadingZipcodes
                      ? "Loading postal codes..."
                      : zipcodesList?.length === 0
                        ? "No postal codes available"
                        : "Select Postal Code"}
                </MenuItem>
                {!isLoadingZipcodes && zipcodesList?.length > 0 &&
                  zipcodesList?.map((zipcode, index) => (
                    <MenuItem key={index} value={zipcode.zipcode || zipcode.name || zipcode}>
                      {zipcode.zipcode || zipcode.name || zipcode}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        );
      case 3:
        return (
          <Box>
            {error && (
              <Alert
                severity="error"
                sx={{
                  width: "calc(100% - 80px)",
                  margin: "9px 40px",
                }}
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                severity="success"
                sx={{
                  width: "calc(100% - 80px)",
                  margin: "9px 40px",
                }}
              >
                {success}
              </Alert>
            )}
            <TextField
              label="Current Password"
              name="currentPassword"
              type={showCurrentPassword ? "text" : "password"}
              margin="normal"
              value={formData?.currentPassword || ""}
              onChange={handleInputChange}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                      edge="end"
                    >
                      {showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "& .MuiOutlinedInput-root": {
                  "&:hover fieldset": {
                    borderColor: "#1976d2", // Change border color on hover
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.3s ease-in-out",
                  },
                },
              }}
            />

            <TextField
              label="New Password"
              name="newPassword"
              type={showNewPassword ? "text" : "password"}
              margin="normal"
              value={formData?.newPassword || ""}
              onChange={handleInputChange}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowNewPassword(!showNewPassword)}
                      edge="end"
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
            <TextField
              label="Confirm Password"
              name="confirmPassword"
              type={showConfirmPassword ? "text" : "password"}
              margin="normal"
              value={formData?.confirmPassword || ""}
              onChange={handleInputChange}
              autoComplete="new-password"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      edge="end"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                width: "calc(100% - 80px)",
                margin: "9px 40px",
                "&:hover": {
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.3s ease-in-out",
                },
              }}
            />
          </Box>
        );
      default:
        return null;
    }
  };

  const stepperDialog = (
    <Dialog
      open={openStepper}
      fullWidth
      maxWidth="sm"
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <DialogTitle>
        {activeStep > 0 && (
          <ArrowBackIcon onClick={handleBack} sx={{ cursor: "pointer" }} />
        )}

        <span
          onClick={() => {
            if (setIsEditClicked) setIsEditClicked(false);
            setOpenStepper(false);
          }}
          style={{ cursor: "pointer", float: "right" }}
        >
          Skip <KeyboardArrowRightIcon />
        </span>
      </DialogTitle>
      <DialogContent>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => (
            <Step key={index}>
              <StepLabel>{ }</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Typography
          variant="h5"
          sx={{ textAlign: "center", marginTop: "20px", fontWeight: 600 }}
        >
          {steps[activeStep]}
        </Typography>

        <Typography
          sx={{
            textAlign: "center",
            marginTop: "20px",
            color: "rgb(102, 112, 133)",
            fontSize: "16px",
          }}
        >
          {lowerStep[activeStep]}
        </Typography>

        <Box sx={{ mt: 4 }}>{renderStepContent(activeStep)}</Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
          {activeStep === steps.length - 1 ? (
            <Button
              onClick={handleChangePassword}
              variant="contained"
              color="primary"
              sx={{ width: "100%", margin: "0 40px 40px 40px" }}
            >
              Change Password
            </Button>
          ) : activeStep === steps.length - 2 ? (
            <Button
              sx={{ width: "100%", margin: "0 40px 40px 40px" }}
              onClick={() => handleSubmit()}
              variant="contained"
              color="primary"
            >
              Save
            </Button>
          ) : (
            <Button
              sx={{ width: "100%", margin: "0 40px 40px 40px" }}
              onClick={() => nextStep()}
              variant="contained"
              color="primary"
            >
              Next
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );

  if (modalOnly) {
    return stepperDialog;
  }

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 600,
        margin: "auto",
        mt: 4,
        backgroundColor: "rgb(245 245 245)",
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      {stepperDialog}
    </Box>
  );
};

export default AdminProfilesettings;
